import { ResourceContentRenderer } from "@/components/portal/render/resource-content-renderer";

type PreviewTool = {
  toolSetupId: string;
  name: string;
  note: string;
  link: string;
  ownerEmail: string;
  state: "pending" | "configured";
  lastAskedAt: string | null;
};

type PreviewSlackChannel = {
  name: string;
  description: string | null;
};

export type PreviewResourceData = {
  title: string;
  behavior?: string;
  renderType: string | null;
  contentBlocks: unknown[];
  notionPayload?: unknown[];
  staleWarning?: boolean;
  empty?: boolean;
  syncedAt?: string | null;
  sourceUrl?: string | null;
  checkedSteps?: number[];
  tools?: PreviewTool[];
  tool?: PreviewTool | null;
  slackChannels?: PreviewSlackChannel[];
};

type Props = {
  data: PreviewResourceData;
  onRefreshNotion?: () => void;
  isRefreshingNotion?: boolean;
};

export function PreviewResourceBody({ data, onRefreshNotion, isRefreshingNotion }: Props) {
  return (
    <ResourceContentRenderer
      data={data}
      readOnly={true}
      onRefreshNotion={onRefreshNotion}
      isRefreshingNotion={isRefreshingNotion}
    />
  );
}
